import { type PropsWithChildren } from 'react';

import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import { I18nextProvider, initReactI18next } from 'react-i18next';

import { getTranslationsLoadPath } from './getTranslationsLoadPath';

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: {
      'en-CA': ['en'],
      'fr-FR': ['fr'],
      default: ['en'],
    },
    preload: ['en', 'fr'],
    debug: false,
    detection: {
      order: ['cookie', 'htmlTag', 'path'],
      caches: ['cookie'],
    },
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
    backend: {
      loadPath: getTranslationsLoadPath(),
    },
  });

export const I18nProvider = ({ children }: PropsWithChildren) => {
  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
};
